(function () {
  'use strict';

  var SEARCH_API = 'https://www.pricecharting.com/api/products';
  var PRODUCT_API = 'https://www.pricecharting.com/api/product';
  var DEBOUNCE_MS = 400;
  var PRICE_CACHE_TTL = 24 * 60 * 60 * 1000; // 24h
  var FETCH_CONCURRENCY = 5;

  var config = {};
  var selectedItems = [];
  var lastSearchTime = 0;

  document.addEventListener('DOMContentLoaded', function () {
    var configEl = document.getElementById('quote-request-config');
    if (!configEl) return;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

    initSearch();
    initManualAdd();
    initFormSubmit();
  });

  /* ── Search (live PriceCharting) ────────────────────── */
  function initSearch() {
    var input = document.getElementById('quote-item-search');
    var results = document.getElementById('quote-item-search-results');
    if (!input || !results) return;

    var timeout;
    input.addEventListener('input', function () {
      clearTimeout(timeout);
      var q = input.value.trim();
      if (q.length < 3) {
        results.style.display = 'none';
        results.innerHTML = '';
        return;
      }
      results.style.display = 'block';
      results.innerHTML = '<div class="quote-search-loading">Searching...</div>';
      timeout = setTimeout(function () { runSearch(q); }, DEBOUNCE_MS);
    });

    document.addEventListener('click', function (e) {
      if (!input.contains(e.target) && !results.contains(e.target)) {
        results.style.display = 'none';
      }
    });

    input.addEventListener('focus', function () {
      if (results.children.length > 0 && input.value.trim().length >= 3) results.style.display = 'block';
    });
  }

  function runSearch(query) {
    var results = document.getElementById('quote-item-search-results');
    if (!config.apiToken) {
      results.innerHTML = '<div class="quote-search-empty">Search unavailable. Add items manually below.</div>';
      return;
    }

    var url = SEARCH_API + '?t=' + encodeURIComponent(config.apiToken) + '&q=' + encodeURIComponent(query);
    var thisSearchTime = Date.now();
    lastSearchTime = thisSearchTime;

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (thisSearchTime !== lastSearchTime) return;

        if (!data || !data.products || data.products.length === 0) {
          results.innerHTML = '<div class="quote-search-empty">No matches. Add it manually below.</div>';
          return;
        }

        var products = data.products.slice(0, 15);
        results.innerHTML = '';
        products.forEach(function (p) {
          var name = p['product-name'] || 'Unknown';
          var consoleName = p['console-name'] || '';
          var pcId = p.id ? String(p.id) : '';
          var row = document.createElement('div');
          row.className = 'quote-search-result';
          row.innerHTML =
            '<div class="quote-search-info"><strong>' + escapeHtml(name) + '</strong>' +
            (consoleName ? '<span>' + escapeHtml(consoleName) + '</span>' : '') +
            '</div>' +
            '<button type="button" class="quote-search-add">+ Add</button>';
          row.querySelector('.quote-search-add').addEventListener('click', function () {
            addItem({ name: name, console: consoleName, source: 'catalog', productId: pcId });
            document.getElementById('quote-item-search').value = '';
            results.style.display = 'none';
            results.innerHTML = '';
          });
          results.appendChild(row);
        });
      })
      .catch(function () {
        results.innerHTML = '<div class="quote-search-empty">Search error. Add it manually below.</div>';
      });
  }

  /* ── Manual add ─────────────────────────────────────── */
  function initManualAdd() {
    var input = document.getElementById('quote-manual-input');
    var btn = document.getElementById('quote-manual-add');
    if (!input || !btn) return;

    btn.addEventListener('click', function () {
      var val = input.value.trim();
      if (!val) return;
      addItem({ name: val, console: '', source: 'manual', productId: '' });
      input.value = '';
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); btn.click(); }
    });
  }

  /* ── Selected item list ─────────────────────────────── */
  function addItem(item) {
    selectedItems.push({
      id: 'q_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7),
      name: item.name,
      console: item.console,
      source: item.source,
      productId: item.productId || '',
      condition: 'loose' // default
    });
    renderSelectedItems();
  }

  function removeItem(id) {
    selectedItems = selectedItems.filter(function (i) { return i.id !== id; });
    renderSelectedItems();
  }

  function setCondition(id, value) {
    var item = selectedItems.find(function (i) { return i.id === id; });
    if (item) item.condition = value;
  }

  function renderSelectedItems() {
    var container = document.getElementById('quote-selected-items');
    if (!container) return;
    if (selectedItems.length === 0) {
      container.innerHTML = '<p class="quote-empty">No items added yet. Search above or add manually.</p>';
      return;
    }
    var html = '<div class="quote-selected-header">' + selectedItems.length + ' item' + (selectedItems.length !== 1 ? 's' : '') + ' added</div>';
    selectedItems.forEach(function (item) {
      html += '<div class="quote-selected-row">' +
        '<div class="quote-selected-info"><strong>' + escapeHtml(item.name) + '</strong>' +
        (item.console ? '<span>' + escapeHtml(item.console) + '</span>' : '') +
        (item.source === 'manual' ? '<em class="quote-selected-tag">Manual</em>' : '') +
        '</div>' +
        '<select class="quote-selected-condition" data-id="' + item.id + '" aria-label="Condition">' +
          '<option value="loose"' + (item.condition === 'loose' ? ' selected' : '') + '>Loose</option>' +
          '<option value="cib"' + (item.condition === 'cib' ? ' selected' : '') + '>Complete in Box</option>' +
          '<option value="new"' + (item.condition === 'new' ? ' selected' : '') + '>New / Sealed</option>' +
        '</select>' +
        '<button type="button" class="quote-selected-remove" data-id="' + item.id + '">&times;</button>' +
        '</div>';
    });
    container.innerHTML = html;
    container.querySelectorAll('.quote-selected-remove').forEach(function (btn) {
      btn.addEventListener('click', function () { removeItem(btn.dataset.id); });
    });
    container.querySelectorAll('.quote-selected-condition').forEach(function (sel) {
      sel.addEventListener('change', function () { setCondition(sel.dataset.id, sel.value); });
    });
  }

  /* ── PriceCharting price fetching ───────────────────── */
  function getCachedPrice(id) {
    try {
      var raw = localStorage.getItem('pcq_' + id);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (Date.now() - entry.ts > PRICE_CACHE_TTL) {
        localStorage.removeItem('pcq_' + id);
        return null;
      }
      return entry.data;
    } catch (e) { return null; }
  }

  function setCachedPrice(id, data) {
    try { localStorage.setItem('pcq_' + id, JSON.stringify({ data: data, ts: Date.now() })); }
    catch (e) {}
  }

  function fetchProductPrice(productId) {
    if (!productId) return Promise.resolve(null);
    var cached = getCachedPrice(productId);
    if (cached) return Promise.resolve(cached);

    var url = PRODUCT_API + '?t=' + encodeURIComponent(config.apiToken) + '&id=' + encodeURIComponent(productId);
    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || data.status === 'error') return null;
        setCachedPrice(productId, data);
        return data;
      })
      .catch(function () { return null; });
  }

  function priceForCondition(data, condition) {
    if (!data) return null;
    var primary, fallbacks;
    if (condition === 'cib') { primary = 'cib-price'; fallbacks = ['loose-price', 'new-price']; }
    else if (condition === 'new') { primary = 'new-price'; fallbacks = ['cib-price', 'loose-price']; }
    else { primary = 'loose-price'; fallbacks = ['cib-price', 'new-price']; }

    // Try primary first, then fallbacks (some products only have loose-price, e.g. Funko POPs)
    var keys = [primary].concat(fallbacks);
    for (var i = 0; i < keys.length; i++) {
      var raw = data[keys[i]];
      if (raw != null) return raw / 100; // PC returns cents
    }
    return null;
  }

  // Fetch all prices for items with productIds, in batches
  function fetchAllPrices(progressCb) {
    var items = selectedItems.filter(function (i) { return i.productId; });
    var total = items.length;
    if (total === 0) return Promise.resolve();

    var done = 0;
    var queue = items.slice();

    function next() {
      if (queue.length === 0) return Promise.resolve();
      var item = queue.shift();
      return fetchProductPrice(item.productId).then(function (data) {
        item._priceData = data;
        done++;
        if (progressCb) progressCb(done, total);
        return next();
      });
    }

    var workers = [];
    for (var i = 0; i < FETCH_CONCURRENCY; i++) workers.push(next());
    return Promise.all(workers);
  }

  /* ── Form Submit ────────────────────────────────────── */
  function initFormSubmit() {
    var form = document.getElementById('QuoteRequestForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (selectedItems.length === 0) {
        alert('Please add at least one item to your quote request.');
        return;
      }

      var name = document.getElementById('quote-req-name').value.trim();
      var email = document.getElementById('quote-req-email').value.trim();
      var phone = document.getElementById('quote-req-phone').value.trim();
      var location = document.getElementById('quote-req-location').value;
      var price = document.getElementById('quote-req-price').value.trim();
      var paymentPref = document.getElementById('quote-req-payment').value;
      var contactMethod = document.getElementById('quote-req-contact-method').value;
      var timeline = document.getElementById('quote-req-timeline').value;
      var why = document.getElementById('quote-req-why').value;
      var notes = document.getElementById('quote-req-notes').value.trim();

      if (!location) { alert('Please select a preferred store.'); return; }
      if (!paymentPref) { alert('Please select Cash or Store Credit.'); return; }
      if (!contactMethod) { alert('Please select your preferred contact method.'); return; }

      var data = {
        name: name, email: email, phone: phone,
        location: location, price: price,
        payment_preference: paymentPref,
        contact_method: contactMethod,
        timeline: timeline, why: why, notes: notes
      };

      // Disable submit button
      var submitBtn = document.getElementById('quote-request-submit');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      // Fetch prices silently in the background, then send to Apps Script
      fetchAllPrices().then(function () {
        submitQuote(data, form);
      }).catch(function (err) {
        console.error('Price fetch error:', err);
        submitQuote(data, form);
      });
    });
  }

  function submitQuote(d, form) {
    // Build items payload with resolved market prices
    var items = selectedItems.map(function (item) {
      var marketPrice = priceForCondition(item._priceData, item.condition);
      return {
        name: item.name,
        console: item.console || '',
        condition: conditionLabel(item.condition),
        marketPrice: marketPrice,
        source: item.source || 'catalog'
      };
    });

    var payload = {
      type: 'custom-quote',
      website: (document.querySelector('#QuoteRequestForm [name="website"]') || {}).value || '',
      formLoadedAt: (document.querySelector('#QuoteRequestForm [name="formLoadedAt"]') || {}).value || '',
      name: d.name,
      email: d.email,
      phone: d.phone,
      location: d.location,
      price: d.price,
      payment_preference: d.payment_preference,
      contact_method: d.contact_method,
      timeline: d.timeline,
      why: d.why,
      notes: d.notes,
      items: items
    };

    // Fire Discord webhook (independent of email)
    postToDiscord(d);

    // Calculate total market value for the Meta Lead event
    var totalMarket = items.reduce(function (sum, it) {
      return sum + (Number(it.marketPrice) || 0);
    }, 0);

    // Fire Meta Pixel Lead event (Facebook ad conversion tracking)
    if (typeof window.fbq === 'function') {
      try {
        window.fbq('track', 'Lead', {
          content_name: 'Custom Quote Request',
          content_category: 'Custom Quote',
          num_items: items.length,
          value: Math.round(totalMarket * 100) / 100,
          currency: 'USD'
        });
      } catch (e) { /* swallow tracking errors */ }
    }

    // POST to Google Apps Script. Uses text/plain to avoid CORS preflight.
    var scriptUrl = config.formsScriptUrl;
    if (!scriptUrl || scriptUrl.indexOf('PASTE_') === 0) {
      console.error('formsScriptUrl not configured');
      alert('Form system not yet configured. Please contact support.');
      return;
    }

    fetch(scriptUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    }).then(function () {
      showSuccess(form);
    }).catch(function (err) {
      console.error('Form submit error:', err);
      // Still show success — no-cors mode always appears to succeed,
      // and Discord already fired. User sees confirmation either way.
      showSuccess(form);
    });
  }

  function showSuccess(form) {
    form.style.display = 'none';
    var successEl = document.getElementById('quote-inline-success');
    if (successEl) successEl.style.display = 'block';
    // Reset selected items state
    selectedItems = [];
    // Scroll to top of the quote section
    var wrap = document.getElementById('quoteRequest');
    if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function formatMoney(n) {
    if (n == null) return 'N/A';
    return '$' + Math.round(n * 100) / 100;
  }

  function conditionLabel(c) {
    if (c === 'cib') return 'CIB';
    if (c === 'new') return 'NEW';
    return 'LOOSE';
  }

  function buildEmailBody(d) {
    var lines = ['CUSTOM QUOTE REQUEST', '====================', ''];
    lines.push('Name: ' + d.name);
    lines.push('Email: ' + d.email);
    lines.push('Phone: ' + d.phone);
    lines.push('Preferred Store: ' + d.location);
    lines.push('');
    lines.push('SALE DETAILS:');
    lines.push('Price Wanted: ' + d.price);
    lines.push('Timeline to Sell: ' + d.timeline);
    lines.push('Why Selling: ' + d.why);
    if (d.notes) { lines.push('Notes: ' + d.notes); }
    lines.push('');
    lines.push('=========================================');
    lines.push('ITEMS (' + selectedItems.length + ') — INTERNAL PC VALUES');
    lines.push('=========================================');

    var totalMarket = 0;
    var pricedCount = 0;
    selectedItems.forEach(function (item, i) {
      var marketPrice = priceForCondition(item._priceData, item.condition);
      var priceStr = marketPrice != null ? formatMoney(marketPrice) : 'N/A';
      if (marketPrice != null) {
        totalMarket += marketPrice;
        pricedCount++;
      }
      var line = (i + 1) + '. [' + conditionLabel(item.condition) + '] ' + item.name;
      if (item.console) line += ' (' + item.console + ')';
      line += ' — Market: ' + priceStr;
      if (item.source === 'manual') line += ' [manual entry — no PC match]';
      lines.push(line);
    });

    lines.push('');
    lines.push('=========================================');
    lines.push('TOTAL MARKET VALUE (priced items only): ' + formatMoney(totalMarket));
    lines.push('Priced: ' + pricedCount + ' / ' + selectedItems.length + ' items');
    lines.push('=========================================');
    lines.push('');
    lines.push('NOTE: Market values are pulled from PriceCharting and reflect');
    lines.push('current loose/CIB/new market price based on customer-selected condition.');
    lines.push('Use these as a baseline when making the trade offer.');

    return lines.join('\n');
  }

  function postToDiscord(d) {
    var webhooks = config.discordWebhooks || {};
    var url = webhooks[d.location];
    if (!url) return;

    // Build item lines with prices
    var totalMarket = 0;
    var itemLines = selectedItems.map(function (item, i) {
      var marketPrice = priceForCondition(item._priceData, item.condition);
      if (marketPrice != null) totalMarket += marketPrice;
      var priceStr = marketPrice != null ? formatMoney(marketPrice) : 'N/A';
      var line = '**' + (i + 1) + '.** [' + conditionLabel(item.condition) + '] ' + item.name;
      if (item.console) line += ' _(' + item.console + ')_';
      line += ' — ' + priceStr;
      if (item.source === 'manual') line += ' `manual`';
      return line;
    });

    // Discord embed field max 1024 chars. Split items into chunks.
    var chunks = [];
    var current = '';
    itemLines.forEach(function (line) {
      if ((current + '\n' + line).length > 1000) {
        chunks.push(current);
        current = line;
      } else {
        current = current ? (current + '\n' + line) : line;
      }
    });
    if (current) chunks.push(current);

    var fields = [
      { name: 'Customer', value: d.name, inline: true },
      { name: 'Email', value: d.email, inline: true },
      { name: 'Phone', value: d.phone || 'N/A', inline: true },
      { name: 'Preferred Store', value: d.location, inline: true },
      { name: 'Price Wanted', value: d.price, inline: true },
      { name: 'Timeline to Sell', value: d.timeline, inline: true },
      { name: 'Why Selling', value: d.why || 'N/A', inline: false },
      { name: 'Total PC Market Value', value: formatMoney(totalMarket), inline: false }
    ];

    // Add up to 5 item-list fields (Discord embeds support max 25 fields total)
    chunks.slice(0, 5).forEach(function (chunk, idx) {
      var label = chunks.length > 1
        ? 'Items (' + selectedItems.length + ') — pt ' + (idx + 1) + '/' + Math.min(chunks.length, 5)
        : 'Items (' + selectedItems.length + ')';
      fields.push({ name: label, value: chunk || 'None', inline: false });
    });
    if (chunks.length > 5) {
      fields.push({ name: 'Note', value: '⚠ ' + (chunks.length - 5) + ' additional item chunks truncated. See email for full list.', inline: false });
    }

    if (d.notes) fields.push({ name: 'Notes', value: d.notes, inline: false });

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        embeds: [{
          title: 'New Custom Quote Request',
          color: 16738563,
          fields: fields,
          footer: { text: 'Play & Talk Quote Request System' },
          timestamp: new Date().toISOString()
        }]
      })
    }).catch(function (err) { console.error('Discord error:', err); });
  }

  /* ── Helpers ────────────────────────────────────────── */
  function escapeHtml(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s || ''));
    return d.innerHTML;
  }
})();
